import { useCallback, useMemo } from "react";

import { useApi } from "shared/services/api/useApi";
import { useQuery } from "react-query";

const useFilters = () => {
    const { getDataAsync } = useApi();

    const getRateCardApiCall = useCallback(async () => {
        const response = await getDataAsync("getRateCards");

        const result = response.status === 204
            ? null
            : response.json();

        return result;

    }, [getDataAsync]);

    const getBizUnitsApiCall = useCallback(async () => {
        const response = await getDataAsync("getBizUnits");

        const result = response.status === 204
            ? null
            : response.json();

        return result;

    }, [getDataAsync]);

    const getUsersApiCall = useCallback(async () => {
        const response = await getDataAsync("getLeadProducers");

        const result = response.status === 204
            ? null
            : response.json();

        return result;

    }, [getDataAsync]);

    const rateCards = useQuery("ratecardsList", getRateCardApiCall);
    const bizUnits = useQuery("bizUnitsList", getBizUnitsApiCall);
    const leadProducers = useQuery("leadProducerList", getUsersApiCall);

    return useMemo(() => {
        return {
            rateCards,
            bizUnits,
            leadProducers,
        };
    }, [rateCards, bizUnits, leadProducers]);
};

export default useFilters;
